import { useTheme } from "../theme/ThemeProvider"
import { ScanLines } from "./demon"
import { SparkleParticles, FloatingStars } from "./fairy"

interface EffectProviderProps {
  children: React.ReactNode
  enableParticles?: boolean
}

export function EffectProvider({ children, enableParticles = true }: EffectProviderProps) {
  const { theme } = useTheme()

  return (
    <>
      {enableParticles && (
        <>
          {theme === "demon" ? (
            <ScanLines />
          ) : (
            <>
              <FloatingStars count={30} />
              <SparkleParticles count={15} />
            </>
          )}
        </>
      )}
      {children}
    </>
  )
}
